import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const MediaItemStyled = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 144px;
  height: 88px;
  border-radius: 2px;
  cursor: pointer;
  background-color: ${COLORS.gray60};
  background-image: url(${props => props.cover});
  background-position: center;
  background-size: cover;

  .active & {
    cursor: default;
  }
`;

export default MediaItemStyled;
